/// Port of mobile/lib/game/sky/moon.dart.

import { SpriteComponent, sprite } from '../engine/sprite';
import { worldWidth } from '../world';
import { moonPhases, skyAssets } from './skyAssets';

interface MoonDeps {
  isPlaying: () => boolean;
  currentScore: () => number;
}

/// Fixed moon in the top-right; steps through phases as score rises.
export class Moon extends SpriteComponent {
  static readonly marginRight = 48.0;
  static readonly marginTop = 10.0;

  /// Score gained per phase advance (cycles 0..6).
  static readonly scorePerPhase = 100;

  private phase = 0;
  private readonly deps: MoonDeps;

  constructor(deps: MoonDeps) {
    super({ priority: -1 });
    this.deps = deps;
    this.applyPhase(0);
  }

  override update(_dt: number): void {
    if (!this.deps.isPlaying()) return;

    const next = Math.floor(this.deps.currentScore() / Moon.scorePerPhase) % moonPhases.count;
    if (next !== this.phase) {
      this.applyPhase(next);
    }
  }

  resetPhase(): void {
    this.applyPhase(0);
  }

  private applyPhase(phase: number): void {
    this.phase = phase;
    const [srcX, srcW] = moonPhases.frames[phase];
    const size = { x: srcW, y: moonPhases.height };

    this.size = size;
    this.sprite = sprite(skyAssets.moonPhase, size, { x: srcX, y: 0 });
    this.pinTopRight();
  }

  private pinTopRight(): void {
    this.position = {
      x: worldWidth - Moon.marginRight - this.size.x,
      y: Moon.marginTop,
    };
  }
}
